
import './styles.css';
import InsaneTable from '../../component/insane-table';

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function Enquipment() {

    let enumList = [];
    let groupList = [];
    let formList = [];
    
    HttpRequest("/admin/pd/enum/get", {}).then(data => {
        // console.log("enumList" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.enums.length; i++) {
                const _enum = data.enums[i];
                enumList.push({
                    displayName: _enum.enumname,
                    value: _enum.enumcode
                })
            }
        }
    });

    HttpRequest("/admin/pd/equipmentgroup/get", {}).then(data => {
        // console.log("_group" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.equipmentgroups.length; i++) {
                const _group = data.equipmentgroups[i];
                groupList.push({
                    displayName: _group.equipmentgroupid + " (" +_group.equipmentgroupname + ")",
                    value: _group.equipmentgroupid
                })
            }
        }
    });

    HttpRequest("/admin/mt/form/get", {}).then(data => {
        // console.log("_form" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.mtresults.length; i++) {
                const _form = data.mtresults[i];
                formList.push({
                    displayName: _form.formcode + " (" +_form.formname + ")",
                    value: _form.formcode
                })
            }
        }
    });

    const tableOption = {
        tableName: "Equipment",
        className: "",
        search: [
            {
                reqName: "equipmentgroupid",
                displayName: "Group",
                placeholder: "Select Group.",
                element: "select",
                option: groupList
            },
            {
                reqName: "tagid",
                displayName: "Tag ID",
                placeholder: "Enter Tag ID.",
                element: "input"
            },
            {
                reqName: "formcode",
                displayName: "Formcode",
                placeholder: "Select Formcode.",
                element: "select",
                option: formList
            }
        ],
        mapTable: [
            {
                displayName: "Group ID",
                attName: "equipmentgroupid",
                type: "id",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: groupList
                }
            },
            {
                displayName: "Equipment ID",
                attName: "equipmentid",
                type: "text",
                form: {
                    validate: false,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "Tag ID",
                attName: "tagid",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "PD Enum Code",
                attName: "pd_enumcode",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: enumList
                }
            },
            {
                displayName: "PD Normal Value",
                attName: "pd_normalvalue",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "PD Normal Value Upper",
                attName: "pd_normalvalue_upper",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "PD Normal Value Enum",
                attName: "pd_normalvalue_enum",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Unit",
                attName: "unit",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Formcode",
                attName: "formcode",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: formList
                }
            },
            {
                displayName: "MT Tolerance",
                attName: "mt_tolerance",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Calibration Period Days",
                attName: "calibration_period_days",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "SEU",
                attName: "seu",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "PI Tag",
                attName: "pi_tag",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/equipment/get",
                dataReq: {
                    "index": 0,
                    "count": 10
                }
            },
            insert: {
                enable: true,
                url: "/admin/equipment/update",
                dataReq: {
                    "equipmentid": "",
                    "tagid": "",
                    "pd_enumcode": "",
                    "pd_normalvalue": "",
                    "pd_normalvalue_upper": "",
                    "pd_normalvalue_enum": "",
                    "unit": "",
                    "equipmentgroupid": "",
                    "formcode": "",
                    "mt_tolerance": "",
                    "calibration_period_days": "",
                    "seu": "",
                    "pi_tag": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/equipment/update",
                dataReq: {
                    "equipmentid": "",
                    "tagid": "",
                    "pd_enumcode": "",
                    "pd_normalvalue": "",
                    "pd_normalvalue_upper": "",
                    "pd_normalvalue_enum": "",
                    "unit": "",
                    "equipmentgroupid": "",
                    "formcode": "",
                    "mt_tolerance": "",
                    "calibration_period_days": "",
                    "seu": "",
                    "pi_tag": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/equipment/delete",
                dataReq: {
                    "equipmentid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            }
        ],
        qr: {
            type: "",
            sampleValue: {
                "type": "equipment",
                "group": "",
                "equipment": ""
            },
            option: {
                bgColor: '#FFFFFF',
                fgColor: '#000000',
                level: 'L',
                size: 64,
                title: ""
            },
            mapValue: [
                {
                    attName: "group",
                    attMap: "equipmentgroupid",
                    type: "text",
                },
                {
                    attName: "equipment",
                    attMap: "equipmentid",
                    type: "text",
                },
            ]
        }
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Equipment Management.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default Enquipment;